import CryptoJS from 'crypto-js';

const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_PRESET;
const BASE_URL = process.env.REACT_APP_CLOUDINARY_URL;

// TEMPORARY API KEY
const API_KEY = process.env.REACT_APP_CLOUDINARY_API_KEY;
const API_SECRET = process.env.REACT_APP_CLOUDINARY_API_SECRET;

/**
 * @param {File} fileToUpload
 * @param {string} productId - Firebase product id
 * @param {number} [imageIndex] - Suffix for gallery images (productId_0, productId_1, ...)
 */
export const uploadImage = async (fileToUpload, productId, imageIndex = null) => {
    const uniqueSuffix = `${Date.now()}_${Math.floor(Math.random() * 1000)}`;
    const publicId =
        imageIndex === null || imageIndex === undefined
            ? `${productId}_${uniqueSuffix}`
            : `${productId}_${imageIndex}_${uniqueSuffix}`;

    const data = new FormData();
    data.append('file', fileToUpload);
    data.append('upload_preset', UPLOAD_PRESET);
    data.append('folder', 'dulce-como-vos/products/pastry');
    data.append('public_id', publicId);

    const res = await fetch(`${BASE_URL}/${CLOUD_NAME}/image/upload`, {
        method: 'POST',
        body: data,
    });

    if (!res.ok) {
        const errorData = await res.json();
        console.error("Cloudinary error details:", errorData);
        throw new Error(
            errorData?.error?.message || "Error al subir la imagen a Cloudinary"
        );
    }

    const responseData = await res.json();
    return responseData.secure_url;
};

/** Uploads multiple gallery images for the same product (parallel). */
export const uploadProductImages = async (files, productId) => {
    return Promise.all(
        files.map((file, index) => uploadImage(file, productId, index))
    );
};

const generateSignature = (params) => {
    const sortedKeys = Object.keys(params).sort();

    const paramString = sortedKeys
        .map(key => `${key}=${params[key]}`)
        .join('&');

    return CryptoJS.SHA1(paramString + API_SECRET).toString();
};

/**
 * Uploads or updates an image using a signed request
 */
export const updateImage = async (fileToUpload, productId) => {
    try {
        const timestamp = Math.round(new Date().getTime() / 1000);
        const folder = 'dulce-como-vos/products/pastry';
        const publicId = productId; // The Firebase product ID

        // Parameters for signature (these must be exact)
        const params = {
            folder: folder,
            invalidate: true,
            overwrite: true,
            public_id: publicId,
            timestamp: timestamp,
        };

        const signature = generateSignature(params);

        const formData = new FormData();
        formData.append("file", fileToUpload);
        formData.append("folder", folder);
        formData.append("public_id", publicId);
        formData.append("timestamp", timestamp);
        formData.append("api_key", API_KEY);
        formData.append("signature", signature);
        formData.append("overwrite", "true");
        formData.append("invalidate", "true");

        const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, {
            method: "POST",
            body: formData,
        });

        if (!res.ok) {
            const errorDetail = await res.json();
            throw new Error(errorDetail.error?.message || "Upload error");
        }

        const data = await res.json();
        // Return URL with timestamp to prevent browser cache
        return `${data.secure_url}?v=${new Date().getTime()}`;
    } catch (error) {
        console.error("Error in updateImage:", error);
        throw error;
    }
};

/**
 * Deletes an image from Cloudinary
 */
export const deleteImage = async (productId) => {
    try {
        const timestamp = Math.round(new Date().getTime() / 1000);
        const publicId = `dulce-como-vos/products/pastry/${productId}`;

        const params = {
            public_id: publicId,
            timestamp: timestamp,
        };

        const signature = generateSignature(params);

        const formData = new FormData();
        formData.append("public_id", publicId);
        formData.append("api_key", API_KEY);
        formData.append("timestamp", timestamp);
        formData.append("signature", signature);

        const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/destroy`, {
            method: "POST",
            body: formData,
        });

        return await res.json();
    } catch (error) {
        console.error("Error deleting image:", error);
        throw error;
    }
};